<template>
	<div class="flex-centerize">
		<v-checkbox v-model="localValue" :disabled="disabled" :label="label" />
		<AppTextTooltip class="pl-2 pb-1" :tooltipText="tooltipMessage">
			<SIcon :name="'circ-info'"></SIcon>
		</AppTextTooltip>
	</div>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'SearchOrCreateToggle',
	mixins: [VModelMixin],
	props: { label: { type: String }, disabled: { type: Boolean } },
	computed: {
		disabledTooltipMessage() {
			return 'Complete all required fields to enable';
		},
		tooltipMessage() {
			return this.disabled
				? this.disabledTooltipMessage
				: 'If on, after filling in all the required fields, extra <br />necessary fields will be added to the form';
		},
	},
};
</script>
<style lang="scss" scoped></style>
